import React from 'react'
import { Form, Input, Row, Col, Message, Select } from 'antd'
import {
  postReduceStock,
  getStockWarningList,
} from '../../../api/businessCommodity'
import '../Merchandise/style.css'

const { TextArea } = Input

export default class extends React.Component {
  state = {
    fromStoreId: '',
    toStoreId: '',

    quantity: 0,
    storeId: '',
    reduceQuantity: '',
    note: '',
    storeList: [],
  }

  componentDidMount() {
    this.getStockList()
  }

  getStockList = async () => {
    const { data, status, detail } = await getStockWarningList(
      this.props.chosenItem.id
    )
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.props.storeList &&
      this.props.storeList.map((item, index) => {
        item.quantity = 0
      })
    this.props.storeList &&
      this.props.storeList.map((item, index) => {
        data &&
          data.map(($item, $index) => {
            if (item.id == $item.store.id) {
              item.quantity = $item.quantity
            }
          })
      })
    this.setState({
      storeList: this.props.storeList,
    })
  }

  postReturnStore = async () => {
    const { reduceQuantity, note, storeId, quantity } = this.state
    if (reduceQuantity && note && storeId) {
      if (reduceQuantity > quantity) {
        Message.error('退库数量不可大于原库存数')
        return
      }
      const params = {
        reduceQuantity: reduceQuantity,
        note: note,
        listingId: this.props.chosenItem.id,
        storeId: storeId,
      }
      const { data, status, detail } = await postReduceStock(params)
      if (status == 1) {
        Message.success('保存成功')
        this.props.setConfirmLoading(false)
        this.props.setIsVisible(false)
        this.props.getList()
      } else {
        Message.error(detail)
        this.props.setConfirmLoading(false)
      }
    } else {
      Message.error('请完整填写信息')
    }
  }

  render() {
    const { reduceQuantity, note, storeId, storeList, quantity } = this.state
    const { chosenItem } = this.props
    return (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
        <Form.Item
          label={
            <span>
              <span>id</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>{chosenItem.id}</Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span>商品图片</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <img
                src={chosenItem.photoUrl}
                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
              />
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span>商品名称</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>{chosenItem.name}</Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>选择仓库</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Select
                value={storeId}
                placeholder="请选择仓库"
                onChange={(value, option) => {
                  this.setState({
                    storeId: value,
                    quantity: storeList[option.key].quantity,
                  })
                }}
              >
                {storeList &&
                  storeList.map((item, idx) => {
                    return (
                      <Select.Option value={item.id} key={idx}>
                        {item.name + ' ( 库存' + item.quantity + ' )'}
                      </Select.Option>
                    )
                  })}
              </Select>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span>原库存</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>{quantity}</Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>退库数量</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Input
                value={reduceQuantity}
                placeholder="请输入退库数量"
                onChange={(e) =>
                  this.setState({ reduceQuantity: e.target.value })
                }
              />
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span>现库存</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              {reduceQuantity ? quantity - reduceQuantity : ''}
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>退库原因</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <TextArea
                value={note}
                maxLength={50}
                onChange={(e) => this.setState({ note: e.target.value })}
                placeholder="请输入退库原因"
                autoSize={{
                  minRows: 3,
                  maxRows: 5,
                }}
              />
            </Col>
          </Row>
        </Form.Item>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/returnStore.js